const imageExtensions: Record<string, string> = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
};

const getChatClipboardImages = (clipboardData: DataTransfer): File[] => {
  const itemFiles = Array.from(clipboardData.items)
    .filter((item) => item.kind === 'file')
    .map((item) => item.getAsFile())
    .filter((file): file is File => file !== null);
  const files = itemFiles.length > 0
    ? itemFiles
    : Array.from(clipboardData.files);

  return files
    .filter((file) => Object.prototype.hasOwnProperty.call(imageExtensions, file.type))
    .map((file, index) => {
      if (/\.(jpe?g|png|webp)$/i.test(file.name)) return file;

      return new File(
        [file],
        `image-${Date.now()}-${index + 1}.${imageExtensions[file.type]}`,
        { type: file.type, lastModified: file.lastModified }
      );
    });
};

export default getChatClipboardImages;
